import React from 'react';
import {
  primaryButtonColor,
  primaryTextColor,
  separatorColor,
} from '../../../styles/SharedStyles';
import { useThemeContext } from '../../../context';

export interface TabContainerProps {
  tabs: { id: string; text: string }[];
  currentTabId: string;
  setCurrentTabId: (newValue: string) => any;
}

export function TabContainer({
  tabs,
  currentTabId,
  setCurrentTabId,
}: TabContainerProps): JSX.Element {
  const theme = useThemeContext();
  return (
    <div
      style={{
        margin: '9px 0 0',
        fontSize: '16px',
        borderBottom: '0.06666666666666667rem solid',
        borderBottomColor: separatorColor(theme),
        paddingBottom: '5px',
      }}
    >
      {tabs.map(tab => (
        <Tab
          key={tab.id}
          text={tab.text}
          selected={tab.id === currentTabId}
          onClick={() => setCurrentTabId(tab.id)}
        />
      ))}
    </div>
  );
}

interface TabProps {
  text: string;
  selected: boolean;
  onClick: () => any;
}

function Tab({ text, selected, onClick }: TabProps): JSX.Element {
  const theme = useThemeContext();
  return (
    <span
      style={{
        borderBottom: selected ? '0.26666666666666666rem solid' : 'none',
        paddingBottom: '2px',
        cursor: 'pointer',
        color: selected ? primaryButtonColor(theme) : primaryTextColor(theme),
        marginRight: '20px',
        userSelect: 'none',
      }}
      onClick={onClick}
    >
      {text}
    </span>
  );
}
